<template>
  <div>
    <HeaderPage>
      <!-- Tableau des rôles -->
      <div class="row">
        <h3 class="mb-4 text-center">Liste des rôles</h3>
        <div class="table-responsive mt-4 mx-auto">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Guard</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="role in roles" :key="role.id">
                <td>{{ role.name }}</td>
                <td>{{ role.guard_name }}</td>
                <td>
                  <button @click="openPermissionModal(role)" class="btn btn-primary btn-sm">
                    Permission
                  </button>
                </td>
                <td>
                  <a href="#" @click.prevent="deleteArticle(article)" class="delete-btn">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Bootstrap -->
      <div class="modal fade show" tabindex="-1" role="dialog" v-if="showModal" style="display: block;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Permissions pour {{ selectedRole.name }}</h5>
              <button type="button" class="close" @click="closeModal">
                <span>&times;</span>
              </button>
            </div>
            <form @submit.prevent="assignPermissions">
              <div class="modal-body">
                <!-- Affichage de toutes les permissions avec checkbox -->
                <div class="form-group">
                  <div v-for="permission in permissions" :key="permission.id" class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :id="'permission-' + permission.id"
                      :value="permission.id"
                      v-model="selectedPermissions"
                    />
                    <label class="form-check-label" :for="'permission-' + permission.id">
                      autorisé à {{ permission.name }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary">Enregistrer</button>
                <button type="button" class="btn btn-danger" @click="closeModal">Annuler</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Backdrop de la modal -->
      <div class="modal-backdrop fade show" v-if="showModal"></div>
    </HeaderPage>
  </div>
</template>

<script>
import axios from "axios";
import HeaderPage from "./components/HeaderPage.vue";

export default {
  name: "RoleList",
  components: { HeaderPage },
  data() {
    return {
      roles: [],
      permissions: [],
      showModal: false,
      selectedRole: {},
      // Contiendra la liste des id des permissions actuellement sélectionnées dans la modal
      selectedPermissions: [],
      // Stocke la liste des permissions initialement associées au rôle (pour comparaison)
      originalPermissions: []
    };
  },
  methods: {
    // Récupère la liste de tous les rôles
    async fetchRoles() {
      try {
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/roles`); 
        this.roles = response.data;
      } catch (error) {
        console.error("Erreur lors de la récupération des rôles :", error);
      }
    },
    // Récupère toutes les permissions disponibles
    async fetchPermissions() {
      try {
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/permission`); 
        this.permissions = response.data;
      } catch (error) {
        console.error("Erreur lors de la récupération des permissions :", error);
      }
    },
    // Récupère les permissions déjà associées au rôle sélectionné
    async fetchAssignedPermissions(roleId) {
      try {
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/role/${roleId}/permissions`); 
        const assigned = response.data.map(item => item.permission_id);
        this.selectedPermissions = assigned;
        this.originalPermissions = [...assigned];
      } catch (error) {
        console.error("Erreur lors de la récupération des permissions assignées :", error);
      }
    },
    // Ouvre la modal et charge toutes les permissions ainsi que celles déjà assignées au rôle
    async openPermissionModal(role) {
      this.selectedRole = role;
      this.showModal = true;
      await this.fetchPermissions();
      await this.fetchAssignedPermissions(role.id);
    },
    closeModal() {
      this.showModal = false;
    },
    // Fonction pour enregistrer les modifications de permissions pour le rôle
    async assignPermissions() {
      const permissionsToAdd = this.selectedPermissions.filter(
        permissionId => !this.originalPermissions.includes(permissionId)
      );
      const permissionsToRemove = this.originalPermissions.filter(
        permissionId => !this.selectedPermissions.includes(permissionId)
      );
      for (const permissionId of permissionsToAdd) {
        try {
          await axios.post("http://127.0.0.1:8000/api/role-permission/add", {
            role_id: this.selectedRole.id,
            permission_id: permissionId
          });
        } catch (error) {
          console.error(`Erreur lors de l'ajout de la permission ${permissionId} :`, error);
        }
      }
      for (const permissionId of permissionsToRemove) {
        try {
          await axios.delete("http://127.0.0.1:8000/api/role-permission/delete", {
            data: {
              role_id: this.selectedRole.id,
              permission_id: permissionId
            }
          });
        } catch (error) {
          console.error(`Erreur lors de la suppression de la permission ${permissionId} :`, error);
        }
      }
      this.closeModal();
    }
  },
  mounted() {
    this.fetchRoles();
  }
};
</script>

<style scoped>
.table-responsive {
  width: 80%;
  max-width: 500px;
  margin: 20px auto;
}

.btn-sm {
  width: 80px;
  padding: 5px;
  font-size: 12px;
}

/* Aligner la checkbox et le libellé sur une même ligne */
.form-check {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.form-check-input {
  margin-right: 10px;
}

/* Réduire la taille du bouton de fermeture (le "x") */
.modal-header .close {
  font-size: 1.2rem;
  width: 30px;
  height: 30px;
  padding: 0;
  background: none;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}
.modal {
  z-index: 1050;
}

.delete-btn {
  color: #dc3545;
}
</style>
